import { render, staticRenderFns } from "./ManuallyItemForm.vue?vue&type=template&id=438c4344&scoped=true&"
import script from "./ManuallyItemForm.vue?vue&type=script&lang=js&"
export * from "./ManuallyItemForm.vue?vue&type=script&lang=js&"
import style0 from "./ManuallyItemForm.vue?vue&type=style&index=0&id=438c4344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c4344",
  null
  
)

export default component.exports